import { useTranslation } from "react-i18next";
import i18n from "i18next";
const t = (key: string, fallback?: string) => i18n.t(key, fallback || key);
import { Button, Dropdown, Form, Layout, MenuProps, message, Modal, Space, TableColumnsType, TableProps, } from "antd";
import { ChangeEvent, KeyboardEvent, useEffect, useMemo, useState, } from "react";
import FilterTableCourseConstruction from "../../../components/course-construction/list-course-construction/filter-table/FilterTable";
import PageHeader from "../../../components/page-header/PageHeader";

import {
  BookOutlined,
  CloudSyncOutlined,
  CopyOutlined,
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  EyeOutlined,
  FileDoneOutlined,
  HistoryOutlined,
  MoreOutlined,
  RedoOutlined,
  SendOutlined,
  ShareAltOutlined,
  ThunderboltOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { routesConfig } from "../../../config/routes";
import "../../../styles/_variables.scss";

import TableData from "../../../components/table-data/TableData";

import { isEmpty } from "lodash";
import moment from "moment";
import FormFilter from "../../../components/course-construction/list-course-construction/filter-group/FormFilter";
import {
  FormCreateCourse
} from "../../../components/course-construction/list-course-construction/form-create-course/FormCreateCourse";
import BrowseCourseModal from "../../../components/modal/browse-course";
import SyncCourseModal from "../../../components/modal/sync-course";
import {
  browseSource,
  courseDelete,
  getAllIndustryGroup,
  getCourseDetail,
  getCourseLevel,
  postCoursePlan,
  postCreateCourse,
  postDuplicateCourse,
  postMoocCoursesSearch,
  putUpdateCourse,
  revokeSource,
  syncSource
} from "../../../service/course-construct";
import { HelpService } from "../../../service/helper.service";
import { getAllEnterpriseUniversityVer2 } from "../../../service/management-participate-platform";
import { Enterprises } from "../../../types/assign-course-construction";
import { ConstructCourseDetailType, DataType, FilterData, } from "../../../types/course-construction";
import { formatOriginTimev3 } from "../../../utils/converDate";
import "./index.scss";
import { globalStore } from "../../../stores/stores";
import { COURSE_STATUS_MAP } from "../../../utils/functionUltils";
import { getCostCourse, getDataGeneral, unPublishContentCourse } from "../../../service/content-course/contenCourseApi";
import PublishContentCourseModal from "../../../components/modal/publish-content-course-modal";

var indexDB = require("idbcache").default;

type ContentConstructionProps = {
  title?: string;
};

const ContentConstruction = (props: ContentConstructionProps) => {
  const { t } = useTranslation();
  const [tab, setTab] = useState(1);
  const { reload, personalInfo, setReload } = globalStore();

  const { title } = props;
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>("");
  const [isOpened, setIsOpened] = useState<boolean>(false);
  const [isOpenedEdit, setIsOpenedEdit] = useState<boolean>(false);
  const [listPlan, setListPlan] = useState<DataType[]>([]);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [browseData, setBrowseData] = useState<DataType>();
  const [isOpenBrowseCourseModal, setIsOpenBrowseCourseModal] = useState<boolean>(false);
  const [isOpenSyncCourseModal, setIsOpenSyncCourseModal] = useState<boolean>(false);
  const [clearForm, setClearForm] = useState<boolean>(false);
  const [syncCourseCheckbox, setSyncCourseCheckbox] = useState<boolean>(false);
  const [quickReviewId, setQuickReviewId] = useState<number>(0);
  const [clearRowkey, setClearRowkey] = useState<boolean>(false);

  const [openPublishContentModal, setOpenPublishContentModal] = useState(false);
  const [dataConfigCourse, setDataConfigCourse] = useState([]);
  const [dataConfigCostCourse, setDataConfigCostCourse] = useState({});
  const [filterData, setFilterData] = useState<FilterData>({
    createDate: null,
    publicDate: null,
    courseType: null,
    status: null,
    enterpriseUUID: null
  });
  const [statusOrder, setStatusOrder] = useState<string>("");
  const [fieldSortOrder, setFieldSortOrder] = useState<string>("");

  const [detailData, setDetailData] = useState<ConstructCourseDetailType>({});
  const [idDetail, setIdDetail] = useState(0);

  const navigate = useNavigate();

  const handleReturnCourseType = (courseType: number) => {
    switch (courseType) {
      case 1:
        return t("Tự triển khai", "Tự triển khai");
      case 2:
        return t("Hợp tác xây dựng", "Hợp tác xây dựng");
      case 3:
        return t("Dùng chung", "Dùng chung");
      default:
        return "";
    }
  };

  const handleToISOString = (day: Date) => {
    const parsedDate = moment(day, ['DD-MM-YYYY', 'Do MMMM YYYY'], true)
    const newDay = moment(parsedDate, 'DD-MM-YYYY')
    const formatDate = moment(newDay).add(1, "day").toISOString()
    return formatDate
  }

  const [form] = Form.useForm();

  const getListDataFilter = () => {
    setPageNumber(1);
    setLoading(true);
    const data = {
      keyword: searchValue,
      page: 1,
      size: pageSize,
      createdDateFrom: !isEmpty(filterData.createDate?.[0])
        ? handleToISOString(filterData.createDate?.[0])
        : "",
      createdDateTo: !isEmpty(filterData.createDate?.[1])
        ? handleToISOString(filterData.createDate?.[1])
        : "",
      publicDateFrom: !isEmpty(filterData.publicDate?.[0])
        ? handleToISOString(filterData.publicDate?.[0])
        : "",
      publicDateTo: !isEmpty(filterData.publicDate?.[1])
        ? handleToISOString(filterData.publicDate?.[1])
        : "",
      status: !isEmpty(filterData.status) ? filterData.status : null,
      courseType: !isEmpty(filterData.courseType)
        ? filterData.courseType
        : null,
      enterpriseUUID: filterData.enterpriseUUID,
      sort: isEmpty(fieldSortOrder) || isEmpty(statusOrder) ? null : [`${fieldSortOrder},${statusOrder}`],
    };
    postMoocCoursesSearch(data)
      .then((res) => {
        const { data } = res.data;
        setListPlan(data.content);
        setTotalRecords(data.totalElements);
        setTimeout(() => {
          setLoading(false);
        }, 500);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const getListData = () => {
    setLoading(true);
    const data = {
      keyword: searchValue,
      page: pageNumber,
      size: pageSize,
      createdDateFrom: !isEmpty(filterData.createDate?.[0])
        ? new Date(filterData.createDate?.[0]).toISOString()
        : "",
      createdDateTo: !isEmpty(filterData.createDate?.[1])
        ? new Date(filterData.createDate?.[1]).toISOString()
        : "",
      publicDateFrom: !isEmpty(filterData.publicDate?.[0])
        ? new Date(filterData.publicDate?.[0]).toISOString()
        : "",
      publicDateTo: !isEmpty(filterData.publicDate?.[1])
        ? new Date(filterData.publicDate?.[1]).toISOString()
        : "",
      status: !isEmpty(filterData.status) ? filterData.status : null,
      courseType: !isEmpty(filterData.courseType)
        ? filterData.courseType
        : null,
      enterpriseUUID: filterData.enterpriseUUID || personalInfo?.enterpriseUUID,
      sort: isEmpty(fieldSortOrder) || isEmpty(statusOrder) ? null : [`${fieldSortOrder},${statusOrder}`],
    };
    postMoocCoursesSearch(data)
      .then((res) => {
        const { data } = res.data;
        setListPlan(data.content);
        setTotalRecords(data.totalElements);
        setTimeout(() => {
          setLoading(false);
        }, 500);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter: any
  ) => {
    const data =
      sorter.order === "ascend"
        ? "asc"
        : sorter.order === "descend"
          ? "desc"
          : "";
    setStatusOrder(data);
    setFieldSortOrder(sorter.field);
  };

  useEffect(() => {
    getListData();
  }, [tab, pageNumber, pageSize, statusOrder, reload, personalInfo?.enterpriseUUID]);

  const helpService = new HelpService();

  const getDetailCourseData = async (id: number) => {
    setLoading(true);
    helpService.loadingProcess();
    try {
      const response = await getCourseDetail(JSON.stringify(id) || "0").then(
        (res) => {
          const { data } = res.data;
          setDetailData(data);
          setTimeout(() => {
            setLoading(false);
            helpService.closeProcess();
            setIsOpened(true);
          }, 500);
        }
      );
    } catch (error) {
      helpService.closeProcess();
      setLoading(false);
    }
  };

  const handleOpenCreate = () => {
    // add course here
    setIdDetail(0);
    setIsOpened(true);
  };

  const handleOpenFilter = () => {
    setShowFilter((showFilter) => !showFilter);
  };

  const handleChangeFilter = (value: any, name: string) => {
    setFilterData({ ...filterData, [name]: value });
  };

  const handleSubmitSearch = () => {
    getListDataFilter();
  };

  const handleSearch = (e: KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === "Enter") {
      getListDataFilter();
    }
  };

  const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearchValue(value);
  };

  const handleCloseFilter = () => {
    setShowFilter(false);
  };

  const clearFilter = () => {
    // setLoading(true)
    form.resetFields();
    setFilterData({
      createDate: null,
      publicDate: null,
      courseType: null,
      status: null,
    });
  };

  const callApi = () => {
    message.success(t("Thu hồi khoá học thành công", "Thu hồi khoá học thành công"));
  };

  const deleteCourse = async (record: any) => {
    if (record.status === 13) {
      message.error(t("Không thể xoá khoá học đã xuất bản", "Không thể xoá khoá học đã xuất bản"));
    } else {
      await courseDelete(record.id).then((res) => {
        if (res.data.statusCode === 200) {
          message.success(t("Khoá học đã được xoá thành công", "Khoá học đã được xoá thành công"));
          getListData();
        }
      });
    }
  };

  const randomCode = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16).replace("-", "");
      }
    );
  };

  const copyData = async (record: any) => {
    await getCourseDetail(record.id).then(async (res) => {
      if (res.status === 200) {
        const obj = res.data.data;
        const listDaculties = obj.faculties.map((item: any) => {
          return item.id;
        });
        const listIndustries = obj.industries.map((item: any) => {
          return item.id;
        });
        const listAssigners = obj.assigners.map((item: any) => {
          return {
            enterpriseUUID: item.enterpriseId,
            assigners: item.assigned.map((result: any) => {
              return {
                teacherId: Number(result.assignUserId),
                instruct: result.instruct,
                construct: result.construct,
              };
            }),
            isSponsor: item.isSponsor,
          };
        });
        obj.name = `${record.name} (${t("Bản sao", "Bản sao")})`;
        obj.code = randomCode().replaceAll("-", "");
        delete obj.id;
        const data = {
          name: obj.name,
          code: obj.code,
          faculties: listDaculties,
          industries: listIndustries,
          coursePlanId: obj.coursePlanId,
          isSynchronizeCourse: true,
          assigns: listAssigners,
        };
        await postDuplicateCourse(record.id)
          .then((res) => {
            message.success(`${t("Tạo bản sao thành công với tên", "Tạo bản sao thành công với tên")} ${data.name}`);
            getListData();
          })
          .catch((err) =>
            message.error(t("Bản sao của khoá học này đã được tạo", "Bản sao của khoá học này đã được tạo"))
          );
      }
    });
  };

  const revokeCourse = async (record: any) => {
    await revokeSource(record.id).then((res) => {
      if (res.status === 200) {
        message.success(t("Yêu cầu thu hồi duyệt khoá học thành công", "Yêu cầu thu hồi duyệt khoá học thành công"));
        getListData();
      }
    });
  };

  const createOptions = (record: any) => {
    const options1: MenuProps["items"] = [
      {
        key: "0",
        label: t("Xem trước khóa học", "Xem trước khóa học"),
        icon: <BookOutlined />,
      },
      {
        key: "1",
        label: t("Sửa khóa học", "Sửa khóa học"),
        icon: <EditOutlined />,
      },
      {
        key: "2",
        label: t("Tạo bản sao", "Tạo bản sao"),
        icon: <CopyOutlined />,
      },
      {
        key: "3",
        label: t("Đồng bộ khóa học", "Đồng bộ khóa học"),
        icon: <CloudSyncOutlined />,
      },
      {
        key: "4",
        label: t("Gửi duyệt khóa học", "Gửi duyệt khóa học"),
        icon: <SendOutlined />,
      },
      {
        key: "5",
        label: t("Thu hồi gửi duyệt khóa học", "Thu hồi gửi duyệt khóa học"),
        icon: <RedoOutlined />,
      },
      ...((record.status === 12 || record.status === 13) ? [
        {
          key: "6",
          label: t("Chia sẻ khóa học", "Chia sẻ khóa học"),
          icon: <ShareAltOutlined />,
        }
      ] : []),
      {
        key: "7",
        label: t("Lịch sử hoạt động", "Lịch sử hoạt động"),
        icon: <HistoryOutlined />,
      },
      {
        key: "8",
        label: t("Xóa khóa học", "Xóa khóa học"),
        icon: <DeleteOutlined />,
        className: "dropdown-delete",
        danger: true,
      },
      ...(record.status !== 13
        ? [
          {
            key: "9",
            label: t("Xuất bản", "Xuất bản"),
            icon: <FileDoneOutlined />,
          },
        ]
        : [
          {
            key: "10",
            label: t("Thu hồi", "Thu hồi"),
            icon: <ThunderboltOutlined />,
          }
        ]),
    ];
    return options1;
  };

  const gotoDetail = (record: any) => {
    navigate(`${routesConfig.contentCourseDetail}/${record.id}`, { state: { mode: "edit", record: record, name: record.name, tab: '1' }, });
  };
  const gotoSetting = (record: any) => {
    navigate(`${routesConfig.contentCourseDetail}/${record.id}`, { state: { mode: "share", record: record, name: record.name, tab: '4' }, });
  };

  const revokeContentCourse = async (id: number) => {
    const data = {
      courseIds: [id]
    }
    try {
      await unPublishContentCourse(data)
      setReload(!reload)
    } catch (error) {
    }
  }

  const getDataConfigCourse = async (id: number) => {
    setLoading(true);
    try {
      const res = await Promise.all([getDataGeneral(id), getCostCourse(id)])
      const dataConfig = res[0].data.data;
      const dataCost = res[1].data.data;
      setDataConfigCourse(dataConfig);
      setDataConfigCostCourse(dataCost);
      setLoading(false)
    } catch (error) {
      console.error(error);
    }
  }

  const dataColumns: TableColumnsType<DataType> = [
    {
      title: "STT",
      dataIndex: "numericalOrder",
      key: "numericalOrder",
      width: 3,
      render: (_: any, record, index: number) => {
        return (
          <span className="table-order-header">{record?.numericalOrder}</span>
        );
      },
    },
    {
      title: t("Tên khoá học", "Tên khoá học"),
      dataIndex: "name",
      key: "name",
      width: 20,
      className: "sequence-name",
      sorter: true,
      render: (_: any, record) => {
        return (
          <div
            className="table-order-course-name cursor-pointer"
            onClick={() => gotoDetail(record)}
          >
            <img
              className="course-img"
              loading="eager"
              alt=""
              src={
                record.imagePath
                  ? record.imagePath
                  : "/images/ic_school_placeholder.svg"
              }
            />
            <div>
              <span
                className="course-title"
              >{record.name}</span>
              <span>{record.enterpriseName}</span>
            </div>
          </div>
        );
      },
    },
    {
      title: t("Trạng thái", "Trạng thái"),
      dataIndex: "status",
      key: "status",
      width: 5,
      render: (_: any, record) => {
        const status = COURSE_STATUS_MAP[record.status];
        if (!status) return null;

        return (
          <div className="table-status">
            <div
              className="color-icon"
              style={{ backgroundColor: status.color }}
            ></div>
            {status.label ? t(status.label, status.label) : ""}
          </div>
        );
      },
    },
    // {
    //   title: t("Loại khóa học", "Loại khóa học"),
    //   dataIndex: "courseType",
    //   key: "courseType",
    //   width: 5,
    //   render: (_: any, record) => {
    //     return (
    //       <div className="table-course-type">
    //         {record.courseType === 2 ? (
    //           <div className="table-course-type-2">
    //             {handleReturnCourseType(record.courseType)}
    //           </div>
    //         ) : record.courseType === 1 ? (
    //           <div className="table-course-type-1">
    //             {handleReturnCourseType(record.courseType)}
    //           </div>
    //         ) : <div className="table-course-type-3">
    //           {handleReturnCourseType(record.courseType)}
    //         </div>}
    //       </div>
    //     );
    //   },
    // },
    {
      title: t("Ngày tạo", "Ngày tạo"),
      dataIndex: "createdDate",
      key: "createdDate",
      width: 5,
      render: (_: any, record) => {
        return (
          <>{record.createdDate ? formatOriginTimev3(record.createdDate) : null}</>
        );
      },
    },
    {
      title: t("Ngày xuất bản", "Ngày xuất bản"),
      dataIndex: "publicDate",
      key: "publicDate",
      width: 5,
      render: (_: any, record) => {
        return (
          <>{record.publicDate ? formatOriginTimev3(record.publicDate) : null}</>
        );
      },
    },
    {
      title: "",
      dataIndex: "action",
      key: "operation",
      render: (_, record) => {
        const location = {
          id: `${record.id}`,
        };

        return (
          <>
            <Space>
              <a
                className="action-table"
                onClick={() =>
                  // xem trước khóa học
                  navigate(`${routesConfig.contentCourseDetail}/${location.id}`, { state: { record, mode: "view", tab: '1' }, })
                }
              >
                <EyeOutlined />
              </a>

              <Dropdown
                menu={{
                  items: createOptions(record),
                  onClick: ({ key }) => {
                    if (key === "0") {
                      indexDB.set("course-id-preview", JSON.stringify({ courseId: location.id, }), 1440);
                      window.open(`/${routesConfig.courseConstruction}/${routesConfig.contentConstruction}/${routesConfig.coursePreview}/${location.id}`, "_blank");
                    }
                    if (key === "1") {
                      setIdDetail(record.id);
                      // setIsOpened(true);
                      setIsOpenedEdit(true);
                      getDetailCourseData(record.id);
                    }
                    if (key === "2") {
                      Modal.confirm({
                        title: `${t("Bạn có muốn tạo bản sao cho", "Bạn có muốn tạo bản sao cho")} ${record.name}`,
                        content: `${t("Tên của bản sao khoá học là", "Tên của bản sao khoá học là")} "${record.name} (${t("bản sao", "bản sao")})"`,
                        onOk: () => copyData(record),
                        okText: t("Lưu", "Lưu"),
                        cancelText: t("Huỷ", "Huỷ"),
                        centered: true,
                        icon: <CopyOutlined style={{ color: "#1677FF" }} />,
                        footer: (_, { OkBtn, CancelBtn }) => (
                          <>
                            <CancelBtn />
                            <OkBtn />
                          </>
                        ),
                      });
                    }
                    if (key === "3") {
                      setIsOpenSyncCourseModal(true);
                      setBrowseData(record);
                    }
                    if (key === "4") {
                      if (record.status === 3) {
                        message.error(
                          t("Khoá học đang trong quá trình chờ duyệt", "Khoá học đang trong quá trình chờ duyệt")
                        );
                      } else {
                        setIsOpenBrowseCourseModal(true);
                        setBrowseData(record);
                      }
                    }
                    if (key === "5") {
                      Modal.confirm({
                        title: `${t("Thu hồi gửi duyệt khoá học", "Thu hồi gửi duyệt khoá học")} ${record.name}`,
                        content: `${t("Bạn có chắc chắn muốn thu hồi gửi duyệt khoá học", "Bạn có chắc chắn muốn thu hồi gửi duyệt khoá học")} ${record.name}?`,
                        onOk: () => revokeCourse(record),
                        centered: true,
                        okText: t("Lưu", "Lưu"),
                        cancelText: t("Huỷ", "Huỷ"),
                        footer: (_, { OkBtn, CancelBtn }) => (
                          <>
                            <CancelBtn />
                            <OkBtn />
                          </>
                        ),
                      });
                    }
                    if (key === "6") {
                      gotoSetting(record);
                    }
                    if (key === "7") {
                      navigate(`${routesConfig.historyCourseConstruction}`, {
                        state: record,
                      });
                    }
                    if (key === "8") {
                      if (record.status !== 13) {
                        Modal.confirm({
                          title: `${t("Xoá khoá học", "Xoá khoá học")} ${record.name}`,
                          content: t("Khoá học đã xoá sẽ không thể khôi phục. Bạn có chắc chắn muốn xoá khoá học?", "Khoá học đã xoá sẽ không thể khôi phục. Bạn có chắc chắn muốn xoá khoá học?"),
                          onOk: () => deleteCourse(record),
                          centered: true,
                          okText: t("Xác nhận", "Xác nhận"),
                          cancelText: t("Huỷ bỏ", "Huỷ bỏ"),
                          footer: (_, { OkBtn, CancelBtn }) => (
                            <>
                              <CancelBtn />
                              <OkBtn />
                            </>
                          ),
                        });
                      } else {
                        message.warning(t("Không thể xóa khóa học đã xuất bản.", "Không thể xóa khóa học đã xuất bản."));
                      }
                    }

                    if (key === "9") {
                      setOpenPublishContentModal(true)
                      setQuickReviewId(record?.id)
                      getDataConfigCourse(record?.id)
                    }
                    if (key === "10") {
                      Modal.confirm({
                        title: t("Xác nhận thu hồi", "Xác nhận thu hồi"),
                        content: `${t("Bạn có chắc chắn muốn thu hồi của khoá học", "Bạn có chắc chắn muốn thu hồi của khoá học")} ${record?.name}?`,
                        onOk: () => {
                          revokeContentCourse(record.id);
                        },
                        okText: t("Xác nhận", "Xác nhận"),
                        cancelText: t("Huỷ", "Huỷ"),
                        centered: true,
                        // icon: <ExclamationCircleOutlined style={{ color: "#1677FF" }} />,
                        footer: (_, { OkBtn, CancelBtn }) => (
                          <>
                            <CancelBtn />
                            <OkBtn />
                          </>
                        ),
                      });
                    }

                  },
                  // else if (key === '2')handleCloseTask
                }}
                placement="bottomRight"
              >
                <Button>
                  <MoreOutlined />
                </Button>
              </Dropdown>
            </Space>
          </>
        );
      },
      fixed: "right",
      width: 3,
    },
  ];

  const defaultCheckedList = dataColumns.map((item) => item.key as string);

  const [checkedList, setCheckedList] = useState(defaultCheckedList);
  const [enterprises, setEnterprises] = useState<Enterprises[]>([]);
  const [industryGroup, setIndustryGroup] = useState<Enterprises[]>([]);
  const [courseLevel, setCourseLevel] = useState<Enterprises[]>([]);
  const [coursePlan, setCoursePlan] = useState<Enterprises[]>([]);
  const [dataUpdate, setDataUpdate] = useState<any>([]);
  const [dataSponsorUpdate, setDataSponsorUpdate] = useState<any>([]);
  const getNumericalNumber = (index: number, page: number, size: number) => {
    return (page - 1) * size + index + 1;
  };

  const newColumns = useMemo(() => {
    return dataColumns.map((item, index: number) => ({
      ...item,
      hidden: !checkedList.includes(item.key as string),
    }));
  }, [checkedList]);

  const listBreadcrumb = [
    {
      title: t("Quản trị cơ sở", "Quản trị cơ sở"),
    },
  ];

  const getListEnterprises = async () => {
    await getAllEnterpriseUniversityVer2({}).then((res) => {
      if (res.status === 200) {
        const listData = res.data?.data?.map((item: any) => ({
          id: item.uuid,
          name: item.name
        }))
        setEnterprises(listData)
      }
    });
  };

  const getListIndustryGroup = async () => {
    try {
      const response = await getAllIndustryGroup().then((res) => {
        const { data } = res.data;
        setIndustryGroup(data);
      });
    } catch (error) {
    }
  };



  const getListCourseLevel = async () => {
    try {
      const response = await getCourseLevel().then((res) => {
        const { data } = res.data;
        setCourseLevel(data);
      });
    } catch (error) {
    }
  };

  const getListCoursePlan = async () => {
    const data = {
      pageNumber: 1,
      pageSize: 1000,
    };
    try {
      const response = await postCoursePlan(data).then((res) => {
        const { data } = res.data;
        setCoursePlan(data.data);
      });
    } catch (error) {
    }
  };

  useEffect(() => {
    getListEnterprises();
    getListIndustryGroup();
    getListCoursePlan();
    getListCourseLevel();
  }, [reload]);

  const confirmModal = () => {
    message.success(t("Phân công khoá học thành công", "Phân công khoá học thành công"));
    setIsOpened(!isOpened);
  };

  const saveBrowseCourse = async (approveUserId: number) => {
    const data = {
      approveUserId: approveUserId,
    };
    await browseSource(browseData?.id, data).then((res) => {
      if (res.status === 200) {
        message.success(t("Yêu cầu duyệt khoá học được gửi thành công", "Yêu cầu duyệt khoá học được gửi thành công"));
        setIsOpenBrowseCourseModal(false);
        setClearForm(true);
        getListData();
      }
    });
  };

  const saveSyncCourse = async (coursePlanId: number, isSync: boolean) => {
    const data = {
      courseId: browseData?.id ?? "",
      coursePlanId: coursePlanId,
      isSync: isSync,
    };
    await syncSource(data).then((res) => {
      if (res.status === 200) {
        message.success(t("Khoá học đã được đồng bộ thành công", "Khoá học đã được đồng bộ thành công"));
        setIsOpenSyncCourseModal(false);
        setClearForm(true);
      }
    });
  };


  const saveCourse = async (
    formValue: any,
    isEdit: boolean,
    courseId: number | null
  ) => {
    const makeAssignBlock = (src: any[], isSponsor: boolean) =>
      src.map((item: any) => ({
        enterpriseUUID: item.enterpriseId || formValue?.hostSchool,
        assigners: item.assigned.map((a: any) => ({
          teacherId: a.assignUserId,
          instruct: !!a.instruct,
          construct: !!a.construct,
        })),
        isSponsor,
      }));

    const assigns = [
      ...makeAssignBlock(dataUpdate.filter((i: any) => i.display), false),
      ...makeAssignBlock(dataSponsorUpdate, true),
    ];

    const payload: Record<string, any> = {
      name: formValue.name,
      code: formValue.code,
      ...(formValue.industryGroup?.length && {
        faculties: formValue.industryGroup.map(Number),
      }),
      ...(formValue.industry?.length && {
        industries: formValue.industry.map(Number),
      }),
      ...(formValue.courseLevel && {
        courseLevel: Number(formValue.courseLevel),
      }),
      ...(assigns.length && { assigns }),
    };

    if (isEdit && courseId) {
      await putUpdateCourse(courseId, payload);
      message.success(`${t("Đã cập nhật", "Đã cập nhật")} “${payload.name}” ${t("thành công", "thành công")}`);
      navigate(
        `${routesConfig.contentCourseDetail}/${courseId}`,
        { state: { mode: "edit", record: detailData, tab: "1" } }
      );
    } else {
      const res = await postCreateCourse(payload);
      message.success(`${t("Đã tạo", "Đã tạo")} “${payload.name}” ${t("thành công", "thành công")}`);
      navigate(
        `${routesConfig.contentCourseDetail}/${res.data.data.id}`,
        { state: { mode: "create", record: { status: 1 }, tab: "1" } }
      );
    }
  };

  const handleSave = (values: any) => {
    saveCourse(values, !!idDetail, idDetail || null);
  };
  return (
    <Layout className="page-header-group course-construction">
      <Form.Provider
        onFormFinish={(name, { values, forms }) => {
          if (name === "create-course-plan-modal") {
            confirmModal();
          }

          if (name === "create-browse-course-modal") {
            saveBrowseCourse(values.lecturerName);
          }

          if (name === "create-sync-course-modal") {
            Modal.confirm({
              title: t("Xác nhận đồng bộ", "Xác nhận đồng bộ"),
              content: t("Bạn có chắc chắn muốn đồng bộ khoá học này?", "Bạn có chắc chắn muốn đồng bộ khoá học này?"),
              onOk: () => {
                saveSyncCourse(values.lecturerName, syncCourseCheckbox);
              },
              okText: t("Xác nhận", "Xác nhận"),
              cancelText: t("Huỷ", "Huỷ"),
              centered: true,
              icon: <ExclamationCircleOutlined style={{ color: "#1677FF" }} />,
              footer: (_, { OkBtn, CancelBtn }) => (
                <>
                  <CancelBtn />
                  <OkBtn />
                </>
              ),
            });
          }

          if (name === "create-course-detail") {
            handleSave(values);
          }
        }}
      >
        <div
          className={`page-header-group--layout ${showFilter ? "open-filter" : ""
            }`}
        >
          <div className="table-header--wrapper">
            <div className="table-header--left">
              <PageHeader title={title} listBreadcrumb={listBreadcrumb} />
            </div>
            <FilterTableCourseConstruction
              handleOpen={handleOpenCreate}
              searchValue={searchValue}
              dataColumns={dataColumns}
              handleOpenFilter={handleOpenFilter}
              handleSubmitSearch={handleSubmitSearch}
              handleSearch={handleSearch}
              checkedList={checkedList}
              setCheckedList={setCheckedList}
              handleChangeInput={handleChangeInput}
              selectedRowKeys={selectedRowKeys}
              tab={tab}
            />
          </div>
          <FormFilter
            enterprises={enterprises}
            handleCloseFilter={handleCloseFilter}
            clearFilter={clearFilter}
            onFinish={handleSubmitSearch}
            filterData={filterData}
            setFilterData={handleChangeFilter}
            form={form}
            showFilter={showFilter}
            tab={tab}
          />
        </div>

        <div className="tabs-heading">
          <TableData
            dataTable={listPlan}
            dataColumns={newColumns}
            setPageNumber={setPageNumber}
            setPageSize={setPageSize}
            pageNumber={pageNumber}
            pageSize={pageSize}
            loadingTable={loading}
            scroll={{ x: 1500, y: 600 }}
            totalRecords={totalRecords}
            setSelectedRowKeysProps={setSelectedRowKeys}
            handleTableChangeProps={handleTableChange}
            pagination={true}
          />
        </div>
        <FormCreateCourse
          enterprises={enterprises}
          industryGroup={industryGroup}
          courseLevel={courseLevel}
          coursePlan={coursePlan}
          id={idDetail}
          detailData={detailData}
          isOpened={isOpened}
          isOpenedEdit={isOpenedEdit}
          setIsOpenedEdit={setIsOpenedEdit}
          setIsOpened={setIsOpened}
          setDetailData={setDetailData}
          setDataUpdate={setDataUpdate}
          setDataSponsorUpdate={setDataSponsorUpdate}
        />
        <BrowseCourseModal
          clearForm={clearForm}
          title={`${t("Gửi duyệt khoá học", "Gửi duyệt khoá học")} ${browseData?.name}`}
          open={isOpenBrowseCourseModal}
          handleOk={confirmModal}
          handleCancel={() => {
            setIsOpenBrowseCourseModal(!isOpenBrowseCourseModal);
          }}
          browseData={browseData}
        />
        <SyncCourseModal
          clearForm={clearForm}
          setSyncCourseCheckbox={setSyncCourseCheckbox}
          title={`${t("Đồng bộ khoá học", "Đồng bộ khoá học")} ${browseData?.name}`}
          open={isOpenSyncCourseModal}
          handleOk={confirmModal}
          handleCancel={() => {
            setIsOpenSyncCourseModal(!isOpenSyncCourseModal);
          }}
          browseData={browseData}
        />

        <PublishContentCourseModal
          dataGeneralConfig={dataConfigCourse}
          dataGeneralCostConfig={dataConfigCostCourse}
          open={openPublishContentModal}
          handleClose={() => setOpenPublishContentModal(false)}
          getListData={getListData}
          quickReviewId={quickReviewId}
          setClearRowkey={setClearRowkey}
        />
      </Form.Provider>
    </Layout>
  );
};

export default ContentConstruction;